const config = {
    data: {
        dataType: {
            recentSearchTerm: 'Recent Search Term',
            predictSearch: 'Predictive Search',
        },
        maxCacheItem: 10,
        delay: 5,
    },
    link: {
        protocol: 'http:',
        sub: '/s',
    },
    manufacturerAdvertised: 'view price in bag',
};

export default config;
